const experience = [
    {
        id: 1,
        company: "Outcomes",
        designation: "Software Engineer 2",
        duration: "April 2026 - Present",
        description: `Building backend services in Java/Spring Boot and Node.js for a B2B MedTech SaaS platform, serving 1M+ requests/day for customer prescriptions.

Key Achievements:
• Built internal AI test-authoring tooling adopted by 30+ engineers — an AI layer over Gauge that generates natural-language test cases without writing step definitions, cutting authoring from 10 hours to 2 hours per module
• Owned a rebuild of the split-order shipment notification flow, replacing confusing multi-tracking-link messages with a single consolidated order view across all sub-shipments and tracking IDs`,
        certificate: ""
    },
    {
        id: 2,
        company: "Louisa AI (Spin-off from Goldman Sachs)",
        designation: "Software Engineer 1",
        duration: "June 2024 - April 2026",
        description: `Architected distributed PySpark and Databricks pipelines processing 3M+ monthly news records for real-time entity intelligence and recommendation systems. Started as a Software Engineer Intern (Jan 2024 - June 2024).

Key Achievements:
• Built large-scale NLP and entity resolution systems using embeddings and similarity matching, raising entity match accuracy from 55% to 85% across 4M+ company profiles
• Developed scalable batch processing and data enrichment workflows orchestrated via Apache Airflow and AWS, achieving 99%+ pipeline reliability
• Reduced personalized query latency by 60% through Elasticsearch optimization`,
        certificate: ""
    },
]

export default experience